document.addEventListener('apz:added', () => {
  const miniCart = document.getElementById('mini-cart')
  if(miniCart && miniCart.open) {
    fetch(miniCart.dataset.url)
      .then(response => response.text())
      .then(html => {
        miniCart.innerHTML = miniCart.getSectionInnerHTML(html, '.shopify-section');
      })
      .catch(e => {
        console.error(e);
      });
    miniCart.open();
  }
})